import type { PetitionDraft } from 'src/app/shared/api/petitionDraft';
import { useClearedMultipleQueryParamsValues, useClearedQueryParamValue } from 'src/app/shared/hooks/location';
import { getLoginOrJoinMethod, LOGIN_OR_JOIN_METHOD_QUERY_KEY } from 'src/app/shared/utils/loginOrJoin';

export function useInitialDraft(draft: PetitionDraft): PetitionDraft {
	const loginOrJoinMethodShortcode = useClearedQueryParamValue(LOGIN_OR_JOIN_METHOD_QUERY_KEY) ?? '';
	const loginOrJoinMethod = getLoginOrJoinMethod(loginOrJoinMethodShortcode) ?? undefined;

	const getUserState = () => {
		return { ...draft.metadata?.user, loginOrJoinMethod: draft.metadata?.user?.loginOrJoinMethod ?? loginOrJoinMethod };
	};

	const [issueParam, personalStoryParam] = useClearedMultipleQueryParamsValues(['issue', 'personal-story']);

	// ChatGPT app entry supports pre-filling issue and personal story via query params.
	// Both params are required to trigger override for ChatApp entry.
	const hasChatAppParams = issueParam != null && personalStoryParam != null;

	if (hasChatAppParams) {
		return {
			...draft,
			input: {
				issuePrompt: decodeURIComponent(issueParam),
				personalStory: decodeURIComponent(personalStoryParam),
			},
			metadata: { ...draft.metadata, user: getUserState() },
		};
	}

	return {
		...draft,
		metadata: { ...draft.metadata, user: getUserState() },
	};
}
